<swiper-container class="customer-item-1 swiper-container" [appSwiper]="config" init="false">
  @for (usertype of customerTypes; track usertype; let i = $index; let first = $first; let last = $last) {
    <swiper-slide class="swiper-slide" [ngClass]="{'borderBox': typeSelected === usertype.ID}">
      @if (isFirst) {
        <mat-card appearance="outlined" class="user-type fx-col">
          <div class="user-type" id="status-user-type-0" [className]="typeSelected == 0?'selected':''"
            (click)="selectType(0)">
            <div class="user-type-heading">{{'unifiedapplication_guest_customer' | translate}}</div>
            <span class="user-type-detail">{{'unifiedapplication_guest_description' | translate}}</span>
            <button class="user-type-select-btn" mat-raised-button color="primary" (click)="collapseSection(0)">
              @if (typeSelected == 0) {
                <mat-icon>check</mat-icon>
              }
              <span>{{(typeSelected == 0 ? "unifiedapplication_selected_btn" : "unifiedapplication_select_btn") |
              translate}}</span>
            </button>
          </div>
        </mat-card>
      }
      <mat-card appearance="outlined" class="user-type fx-col">
        <div id="status-user-type-{{usertype.ID}}"
          [className]="typeSelected == usertype.ID?'selected':''" (ngInit)="setScrollPosition()"
          (click)="selectType(usertype.ID)">
          <div class="user-type-heading" [translate]="'unifiedapplication_user_type_'+usertype.ID"> </div>
          <div class="user-type-detail" [translate]="'unifiedapplication_user_description_'+usertype.ID"> </div>
          <button mat-raised-button  color="primary" class="user-type-select-btn" (click)="collapseSection(usertype.ID)">
            @if (typeSelected == usertype.ID) {
              <mat-icon>check</mat-icon>
            }
            <span>{{(typeSelected == usertype.ID ? "unifiedapplication_selected_btn" :
            "unifiedapplication_select_btn") | translate}}</span>
          </button>
        </div>
      </mat-card>
    </swiper-slide>
  }
  <div slot="container-end" class="footerButton">
    <button mat-button class="swiper-button-prev swipe-arrow">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-button class="swiper-button-next swipe-arrow">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
</swiper-container>
